import { WysiwygEditorStateContext } from '@src/contexts/wysiwyg/editor';
import type { TRect } from '@src/types/misc';
import type {
  TextContentStyles,
  TextContentStyleOverrides,
  TTextBoxContentItem
} from '@src/types/wysiwyg_editor';
import { useContext } from 'react';
import _merge from 'lodash/merge';

interface ConfigOverrides {
  containerLocation?: TRect;
  contentLocation?: TRect;
  styles?: TextContentStyles;
}

type Generator = (overrides?: ConfigOverrides) => TTextBoxContentItem;

const defaultStyles: TextContentStyles = {
  align: 'center',
  color: '#333333',
  face: 'open-sans',
  lineHeight: '1.5', // must be a string otherwise it won't merge by prosemirror since it uses a string parser
  size: 15,
  style: 'normal',
  weight: '300'
};

const contentTypeId = 'text_box';
let generationId = 1;

function styles(overrides: TextContentStyleOverrides = {}): TextContentStyles {
  return { ...defaultStyles, ...overrides };
}

export function useTextBoxGenerator(): Generator {
  const { defaultTextAlignment } = useContext(WysiwygEditorStateContext);

  return function textBoxGenerator(overrides = {}) {
    const id = `${contentTypeId}-g-${generationId++}-${Date.now()}`;

    const location = {
      height: 0.3,
      width: 0.5,
      x: 0.25,
      y: 0.35
    };

    const config = {
      id,
      containerLocation: location,
      contentLocation: {
        x: 0,
        y: 0,
        height: location.height,
        width: location.width
      },
      content: null,
      hideOverflow: true,
      styles: styles({ align: defaultTextAlignment }),
      type: contentTypeId
    };

    return _merge(config, overrides);
  };
}
